import { useFlag } from '@unleash/proxy-client-react'
import { useExperiment } from 'src/hooks/useExperiment'
import {
  FF_RESURRECTION_CONTENTFUL_ENABLED,
  FF_NEW_LANDING_PAGES_REDESIGN
} from 'src/constants/feature-flags'

export interface ResurrectionSections {
  hero: boolean
  featuredMeals: boolean
  info: boolean
  footer: boolean
}

export function useResurrectionFlags() {
  const contentfulOn = useFlag(FF_RESURRECTION_CONTENTFUL_ENABLED)
  const { active: redesignOn, payload } = useExperiment(
    FF_NEW_LANDING_PAGES_REDESIGN
  )

  // Normalize section flags from experiment payload
  const sectionsRaw =
    payload?.type === 'json' && payload.value?.sections
      ? payload.value.sections
      : {}

  const sections: ResurrectionSections = {
    hero: Boolean(sectionsRaw.hero),
    featuredMeals: Boolean(sectionsRaw.featuredMeals),
    info: Boolean(sectionsRaw.info),
    footer: Boolean(sectionsRaw.footer)
  }

  return {
    contentfulOn,
    redesignOn,
    sections,
    // Raw values for tracking/analytics
    rawPayload: payload
  }
}
